import React, {useEffect, useRef} from 'react';
import {
  ActivityIndicator,
  FlatList,
  Linking,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import {SafeAreaView, useSafeAreaInsets} from 'react-native-safe-area-context';
import {connect} from 'react-redux';
import {Color, globalFontStyle, globalStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import Width from '../../../assets/Width';
import FastImage from '../../../common/FastImage';
import FormTextLabel from '../../../commonComponents/FormTextLabel';
import {back_arrow_white, smile_coin} from '../../../utils/images';
import {getUser} from '../../Profile/redux/profile.action';
import {globalConfigurableData} from '../../../utils/globalConstant';
import {isMobile} from '../../../utils/commonMethods';
import {RefreshControl} from 'react-native-web-refresh-control';
import NoMarket from '../../../commonComponents/NoMarkets';
import MarkeMakingCard from '../childComponents/MarketMakingCards';
import {getMMDetails} from '../redux/rewards.action';
import {TimerApp} from '../../../commonComponents/timer';
import Gradient from '../../../commonComponents/Gradient';
import { useToast } from '../../../components/core/Toast';
import { Icon } from '@iconify/react';

let {height, width} = Width;

const MarketMaking = ({
  navigation,
  route,
  mmDetailsData,
  mmDetailsLoading,
  getMMDetails,
}) => {
  const { toast } = useToast();
  const insets = useSafeAreaInsets();

  useEffect(() => {
    PullToRefresh();
  }, []);

  const openURL = link => {
    if (link && link !== undefined && link !== 'undefined') {
      Linking.canOpenURL(link).then(supported => {
        if (supported) {
          Linking.openURL(link);
        } else {
          alert('Issues in Opening the URL, try after sometime');
          console.log("Don't know how to open URI: " + link);
        }
      });
    }
  };

  const handleEmpty = () => {
    return <NoMarket innerContestCondition={true} source="contest_events" />;
  };

  const onCardClick = item => {
    if (Date.parse(item?.endsat) < Date.now()) {
      toast({
        title: 'This event is no longer active',
        variant: 'destructive'
      });
    } else {
      navigation.navigate('Event', {
        eventId: item.id,
        isMulti: item.parent_id === -1 ? true : false,
      });
    }
  };

  const PullToRefresh = async () => {
    await getMMDetails();
  };

  const renderProbeCard = ({item, index}) => {
    return (
      <TouchableOpacity
        style={{flex: 1, paddingHorizontal: 16}}
        onPress={() => onCardClick(item)}
        delayPressIn={0}
        key={item.id}>
        <MarkeMakingCard t={item} />
      </TouchableOpacity>
    );
  };

  const headerComponent = () => {
    return (
      <Gradient
        colors={['#002B88', '#0A57FF']}
        end={{x: 0, y: 1}}
        style={styles.top_box}>
        <View style={{flexDirection: 'row'}}>
          <TouchableOpacity
            style={{
              marginTop: 15,
              marginBottom: 20,
              padding: 6,
              borderRadius: 100,
              backgroundColor: '#0A57FF',
            }}
            onPress={() => {
              if (!navigation.canGoBack()) {
                navigation.navigate('Home');
              } else {
                navigation.pop(1);
              }
            }}>
            <Icon 
              icon="tabler:arrow-left"
              style={{ width: 24, height: 24 }}
              color="#FFFFFF"
            />
          </TouchableOpacity>
        </View>
        <FormTextLabel
          labelStyles={{
            ...globalFontStyle.appFontHeading,
            color: globalConfigurableData.globalThemeColor,
          }}
          label={mmDetailsData?.title}
        />
        <FormTextLabel
          labelStyles={{
            ...globalFontStyle.appFontBody,
            color: 'rgba(236, 214, 80, 1)',
            marginTop: 5,
          }}
          label={mmDetailsData?.description}>
          {mmDetailsData?.cta && (
            <Text
              style={{
                ...globalFontStyle.appFontBody,
                color: globalConfigurableData.globalThemeColor,
                textDecorationLine: 'underline',
                textDecorationColor: 'white',
                textDecorationStyle: 'solid',
                marginLeft: 3,
              }}
              onPress={() => {
                openURL(mmDetailsData?.cta?.link);
              }}>
              {mmDetailsData?.cta?.text}
            </Text>
          )}
        </FormTextLabel>
        <View style={styles.bottomRow}>
          <View style={{alignItems: 'flex-start'}}>
            <FormTextLabel
              labelStyles={[
                globalFontStyle.appFontSmallText,
                {
                  color: globalConfigurableData.globalThemeColor,
                  textAlign: 'right',
                  paddingBottom: 5,
                },
              ]}
              label={'Time left this week'}
            />
            <View style={[styles.cardBtn]}>
              <TimerApp
                deadline={mmDetailsData?.endTime}
                isMarketMaking={true}
                customStyle={{
                  ...globalFontStyle.appFontSubHeading,
                  color: globalConfigurableData.globalThemeColor,
                }}
              />
            </View>
          </View>
          <View
            style={{
              width: 1,
              backgroundColor: colors.bgWhite,
              height: '100%',
            }}
          />
          <View style={{alignItems: 'center'}}>
            <FormTextLabel
              labelStyles={[
                globalFontStyle.appFontSmallText,
                {
                  color: globalConfigurableData.globalThemeColor,
                  textAlign: 'right',
                  paddingBottom: 5,
                },
              ]}
              label={'Matched shares'}
            />
            <View style={[styles.cardBtn]}>
              <Text
                style={[
                  globalFontStyle.appFontSubHeading,
                  {color: globalConfigurableData.globalThemeColor},
                ]}>
                {mmDetailsData?.matched_contracts
                  ? mmDetailsData?.matched_contracts
                  : '-'}
              </Text>
            </View>
          </View>
          <View
            style={{
              width: 1,
              backgroundColor: colors.bgWhite,
              height: '100%',
            }}
          />
          <View style={{alignItems: 'center'}}>
            <FormTextLabel
              labelStyles={[
                globalFontStyle.appFontSmallText,
                {
                  color: globalConfigurableData.globalThemeColor,
                  textAlign: 'right',
                  paddingBottom: 5,
                },
              ]}
              label={'Token Points Rewards'}
            />
            <View style={[styles.cardBtn]}>
              <FastImage
                style={{width: 15, height: 15, marginRight: 5}}
                source={smile_coin()}
              />
              <Text
                style={[
                  globalFontStyle.appFontSubHeading,
                  {color: globalConfigurableData.globalThemeColor},
                ]}>
                {mmDetailsData?.reward_tokens}
              </Text>
            </View>
          </View>
        </View>
      </Gradient>
    );
  };

  return (
    <>
      {!mmDetailsData && (
        <TouchableOpacity style={[styles.container]} activeOpacity={1}>
          <ActivityIndicator
            size="large"
            color={globalConfigurableData.loaderColor}
          />
        </TouchableOpacity>
      )}
      <View
        style={[
          {
            backgroundColor: Color.bgWhite,

            paddingTop: insets.top,
            //paddingBottom: insets.bottom,
            paddingLeft: insets.left,
            paddingRight: insets.right,
          },
          isMobile() ? globalStyle.scroll_webFix : {},
        ]}>
        <View>
          <FlatList
            scrollEnabled={true}
            data={mmDetailsData?.probes}
            renderItem={renderProbeCard}
            keyExtractor={(item, index) => item?.id}
            showsVerticalScrollIndicator={false}
            initialNumToRender={10}
            //getItemLayout={getItemLayoutFun}
            updateCellsBatchingPeriod={15}
            ListHeaderComponent={headerComponent()}
            //maxToRenderPerBatch={4}

            contentContainerStyle={[
              {
                paddingBottom: mmDetailsData?.probes?.length > 0 ? 150 : 0,
              },
            ]}
            ListEmptyComponent={handleEmpty}
            onRefresh={PullToRefresh}
            refreshing={mmDetailsLoading}
            refreshControl={
              isMobile() ? (
                <RefreshControl
                  colors={[Color.tradexBlue]}
                  refreshing={mmDetailsLoading}
                  onRefresh={PullToRefresh}
                />
              ) : null
            }
          />
        </View>
      </View>
    </>
  );
};

const mapStateToProps = ({rewardsReducer}) => ({
  mmDetailsData: rewardsReducer.mmDetailsData,
  mmDetailsLoading: rewardsReducer.mmDetailsLoading,
});
const mapDispatchToProps = {
  getMMDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(MarketMaking);

const styles = StyleSheet.create({
  top_box: {
    alignContent: 'center',
    backgroundColor: Colors.tradexBlue,
    paddingTop: 30,
    paddingHorizontal: 16,
  },
  bottomRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 10,
    backgroundColor: '#286BFF',
    borderRadius: 5,
    marginBottom: 15,
    paddingHorizontal: 20,
    paddingVertical: 10,
  },
  cardBtn: {
    borderColor: globalConfigurableData.primaryTextColor1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    // flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    position: 'absolute',
    zIndex: 1111,
    top: 0,
    left: 0,
    height,
    width,
  },
});
